import Container from './DescriptionBatchEdit.container';
import DescriptionBatchEdit from './DescriptionBatchEdit';

export default Container(DescriptionBatchEdit);
